import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { useEnquiryModal } from "./EnquiryModal";

const FooterMain = () => {
    const { openModal } = useEnquiryModal();
    return (
        <div>
            <footer className="bg-sky-900 text-white py-12 px-6 md:px-20">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {/* Logo & Text */}
                    <div className="">
                        {/* <h2 className="text-3xl font-bold tracking-wide">NOVA</h2> */}
                        {/* <img src="../Assets/emaar-black.svg" alt="logo" className="w-48 items-start invert opacity-100" /> */}
                    </div>

                    {/* Specialization */}
                    <div className="">
                        <p className="text-md leading-relaxed">
                            We specialize in connecting discerning clients with the finest
                            properties UAE has to offer.
                        </p>
                    </div>

                    {/* button */}
                    <div className="">
                        <button onClick={openModal} className="text-center justify-center flex gap-2 w-full items-center p-3 rounded-lg font-semibold border-2 border-white bg-[#f6f8f2] text-[#003153] hover:text-white hover:bg-sky-900 transition-colors">
                            <span className="text-md mt-1">REGISTER INTEREST</span>
                        </button>
                    </div>
                </div>

                {/* Bottom Footer */}
                <div className="border-t pb-10 lg:pb-0 border-white/20 mt-5 pt-6 text-sm flex flex-col md:flex-row justify-between md:items-center">
                    <p>© 2025  Nova Capital Real Estate L.L.C. All rights reserved.</p>
                    <div className="space-x-6 mt-4 md:mt-0">
                        <Link to="/privacy-policy" className="hover:text-gray-300">Privacy Policy | Terms & Conditions</Link>
                    </div>
                </div>
            </footer>

            {/* Fixed Mobile Footer Buttons */}
            <div className="fixed bottom-0 left-0 w-full bg-[#003153] shadow-md lg:hidden z-50">
                <div className="justify-around w-full p-2 space-x-2">
                    <button onClick={openModal} className="flex-1 text-center justify-center flex gap-2 w-full items-center p-2 rounded-lg font-semibold bg-[#f6f8f2] text-[#003153] hover:text-white hover:bg-[#003153] transition-colors">
                        <i className="fas fa-envelope text-lg"></i>
                        <span className="text-md mt-1">ENQUIRY NOW</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FooterMain;
